import { createSlice } from "@reduxjs/toolkit";
import {
  createHotelAmenity,
  deleteHotelAmenity,
  deleteUndoHotelAmenity,
  fetchAmenity,
  fetchOneAmenity,
  updateHotelAmenity,
} from "./amenityThunks";

const initialState = {
  data: [],
  oneAmenity: null,
  totalPages: 1,
  totalItems: 0,
  loading: false,
  error: null,
};

const hotelAmenitySlice = createSlice({
  name: "hotelAmenity",
  initialState,

  extraReducers: (builder) => {
    builder
      // get All Hotel Amenities
      .addCase(fetchAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.totalItems = action.payload.totalItems;
      })
      .addCase(fetchAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // get One Amenity
      .addCase(fetchOneAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOneAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.oneAmenity = action.payload;
      })
      .addCase(fetchOneAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Hotel Amenities
      .addCase(createHotelAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createHotelAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(createHotelAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Hotel Amenities
      .addCase(updateHotelAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHotelAmenity.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.data.findIndex(
          (item) => item._id === action.payload.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(updateHotelAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Hotel Amenities
      .addCase(deleteHotelAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHotelAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((item) => item._id !== action.payload);
      })
      .addCase(deleteHotelAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Undo Delete Hotel Amenities
      .addCase(deleteUndoHotelAmenity.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteUndoHotelAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((item) => item._id !== action.payload);
      })
      .addCase(deleteUndoHotelAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default hotelAmenitySlice.reducer;
